module.exports = __webpack_public_path__ + "static/media/0323_Medium.f4f6be7c.jpg";